import { render, staticRenderFns } from "./index.vue?vue&type=template&id=24c640a6&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=24c640a6&lang=scss&scoped=true"
import style1 from "./index.vue?vue&type=style&index=1&id=24c640a6&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24c640a6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\zjj\\view-pc\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('24c640a6')) {
      api.createRecord('24c640a6', component.options)
    } else {
      api.reload('24c640a6', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=24c640a6&scoped=true", function () {
      api.rerender('24c640a6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/fd/examine/index.vue"
export default component.exports